import { useSearchParams } from 'react-router-dom';
import { getErrorMessage } from '../lib/errorMessages';
import { FaExclamationCircle } from 'react-icons/fa';
import { appEnv } from '../lib/env';

export function ErrorPage() {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || searchParams.get('error_type');

  const errorMessage = type
    ? getErrorMessage(type)
    : searchParams.get('message') || 'An unexpected error occurred.';

  return (
    <div className="main-container">
      <div className="main-container-top" style={{ alignItems: 'center', textAlign: 'center' }}>
        <FaExclamationCircle size={64} color="#F50000" style={{ marginBottom: '16px' }} />
        <h2 style={{ color: '#F50000' }}>Error</h2>
        <p className="main-text">{errorMessage}</p>
      </div>
      <a href={appEnv.logoFrontendUrl} className="btn-link">
        <button className="secondary">
          <span />
          <span>HOME</span>
          <img src="/assets/arrow_right.svg" alt="" width="24" height="24" />
        </button>
      </a>
    </div>
  );
}
